let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("a4Sf9"), load("6zfzy"), load("6Yu8N"), load("bCr24")]).then(() => parcelRequire('arPKr'));